import { Container } from "@mui/system";
import { Grid, Typography, Box, TextField, Button, Dialog, Accordion, AccordionSummary, AccordionActions, DialogTitle, DialogActions, FormControl, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import LoadingButton from "@mui/lab/LoadingButton";
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import EmailIcon from '@mui/icons-material/Email';
import globals from "../globals";

const UserDashboard = () => {

    const { token, login } = useAuth()

    const [filterName, setFilterName] = useState('');
    const [userState, setUserState] = useState([]);
    const [openDialog, setOpenDialog] = useState(null); // Track which user's dialog is open (userId or null)
    const [dialogType, setDialogType] = useState('');
    const [dialogAction, setDialogAction] = useState();
    const [radioFilter, setRadioFilter] = useState('all');
    const [loadingStates, setLoadingStates] = useState({}); // Track loading by userId and button type

    useEffect(() => {

        fetch(globals.apiUrl + '/admin/users', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        })
            .then(response => response.json())
            .then(data => {
                setUserState(data);
            })
            .catch(error => {
                console.error('Error:', error);
            })
    }, []);

    const combineName = (instructor) => {
        return instructor.first_name + ' ' + instructor.last_name
    }

    const filterFunction = () => {

        let radioFilterUsers = [...userState];

        if (radioFilter == 'active') {
            radioFilterUsers = userState.filter(user => user.is_active && user.role == 'student')
        } else if (radioFilter == 'notactive') {
            radioFilterUsers = userState.filter(user => !user.is_active && user.role == 'student')
        } else if (radioFilter == 'instructor') {
            radioFilterUsers = userState.filter(user => user.role == 'instructor')
        }

        return radioFilterUsers.filter(user => combineName(user).toLocaleLowerCase().includes(filterName.toLocaleLowerCase()) || user.email.toLocaleLowerCase().includes(filterName.toLocaleLowerCase()))
    }

    const handleClickOpenDialog = (userId, type, action) => {
        setDialogType(type);
        setDialogAction(() => action);
        setOpenDialog(userId);
    };

    const handleCloseDialog = (callAction) => {
        if (callAction) {
            dialogAction()
        }
        setOpenDialog(null);
        setDialogType('');
    };

    const changeRole = (id) => {
        setLoadingStates(prev => ({ ...prev, [`${id}-promote`]: true }));

        fetch(globals.apiUrl + `/admin/users/${id}/promote`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            })
            .then(response => response.json())
            .then(data => {
                setUserState(userState.map(user => (
                    user.id == id ? { ...user, role: 'instructor' } : user
                )))
                setLoadingStates(prev => ({ ...prev, [`${id}-promote`]: false }));
            })
            .catch(error => {
                console.error('Error:', error);
                setLoadingStates(prev => ({ ...prev, [`${id}-promote`]: false }));
            })
    }

    const impersonateUser = (id) => {
        setLoadingStates(prev => ({ ...prev, [`${id}-impersonate`]: true }));

        fetch(globals.apiUrl + `/admin/users/${id}/impersonate`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            })
            .then(async response => {
                const data = await response.json();
                if (!response.ok) {
                    throw new Error(typeof data.detail === 'string' ? data.detail : 'Неуспешно влизане като потребител');
                }
                login(data);
            })
            .catch(error => {
                console.error('Error:', error);
                window.alert(error.message);
                setLoadingStates(prev => ({ ...prev, [`${id}-impersonate`]: false }));
            })
    }

    const deleteUser = (id) => {
        setLoadingStates(prev => ({ ...prev, [`${id}-delete`]: true }));

        fetch(globals.apiUrl + `/admin/users/${id}/delete`,
            {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            })
            .then(response => response.json())
            .then(data => {
                setUserState(userState.filter(user => user.id != id))
                setLoadingStates(prev => ({ ...prev, [`${id}-delete`]: false }));
            })
            .catch(error => {
                console.error('Error:', error);
                setLoadingStates(prev => ({ ...prev, [`${id}-delete`]: false }));
            })
    }

    return (
        <Container>
            <Grid container>
                <Grid item sm={6}>
                    <Typography sx={{ fontWeight: 'bold', fontSize: 25, textTransform: 'uppercase' }}>
                        Потребители
                    </Typography>
                </Grid>
                <Grid item sm={6}>
                    <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                        <SearchIcon fontSize='large' sx={{ color: 'action.active', mr: 1, my: 1 }} />
                        <TextField fullWidth placeholder="Търсене" onChange={(event) => setFilterName(event.target.value)} />
                    </Box>
                </Grid>
            </Grid>

            <Grid>
                <FormControl onChange={(event) => { setRadioFilter(event.target.value) }}>
                    <RadioGroup
                        defaultValue="all"
                    >
                        <Grid container>
                            <Grid item>
                                <FormControlLabel value="all" control={<Radio />} label="Всички" />
                            </Grid>
                            <Grid item>
                                <FormControlLabel value="instructor" control={<Radio />} label="Учител" />
                            </Grid>
                            <Grid item>
                                <FormControlLabel value="active" control={<Radio />} label="Активен ученик" />
                            </Grid>
                            <Grid item>
                                <FormControlLabel value="notactive" control={<Radio />} label="Неактивен ученик" />
                            </Grid>
                        </Grid>
                    </RadioGroup>
                </FormControl>
            </Grid>


            <Grid container sx={{ mt: 2 }} spacing={1}>
                {filterFunction().map(user => (
                    <Grid item sm={12} key={user.id}>
                        <Accordion fullWidth>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography component="span"> <strong>{combineName(user)}</strong> | {user.email} {user.is_subscribed && <EmailIcon sx={{ mb: -1 }} />}</Typography>
                            </AccordionSummary>
                            <AccordionActions>
                                {user.role != 'admin' && <LoadingButton loading={loadingStates[`${user.id}-impersonate`] || false} color='primary' variant="contained" onClick={() => handleClickOpenDialog(user.id, 'impersonate', () => impersonateUser(user.id))}>Влез като</LoadingButton>}
                                {user.role == 'instructor' && <LoadingButton href={`/admin-edit-profile/${user.id}`} variant="contained" color='secondary'>Редактирай</LoadingButton>}
                                {user.role == 'student' && <LoadingButton loading={loadingStates[`${user.id}-promote`] || false} color='success' variant="contained" onClick={() => handleClickOpenDialog(user.id, 'create', () => changeRole(user.id))}>Направи учител</LoadingButton>}

                                <LoadingButton loading={loadingStates[`${user.id}-delete`] || false} onClick={() => handleClickOpenDialog(user.id, 'delete', () => deleteUser(user.id))} variant='contained' color="error">Изтрий</LoadingButton>
                                <Dialog
                                    open={openDialog === user.id}
                                    onClose={handleCloseDialog}
                                >
                                    <DialogTitle id="alert-dialog-title">
                                        {dialogType == "delete" ? "Искате ли да изтриете този потребител?" : dialogType == "impersonate" ? "Искате ли да влезете като този потребител?" : "Искате ли да направите този потребител УЧИТЕЛ?"}
                                    </DialogTitle>
                                    <DialogActions>
                                        <Button onClick={() => handleCloseDialog(true)}>Да</Button>
                                        <Button onClick={() => handleCloseDialog(false)} autoFocus>
                                            Не
                                        </Button>
                                    </DialogActions>
                                </Dialog>

                            </AccordionActions>
                        </Accordion>
                    </Grid>
                ))}
            </Grid>
        </Container>
    )
}

export default UserDashboard
